/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface Audit
 */
export interface Audit {
    /**
     * 
     * @type {number}
     * @memberof Audit
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    more_detail: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    detail: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    claim_ref?: string;
    /**
     * 
     * @type {User}
     * @memberof Audit
     */
    user?: User;
    /**
     * 
     * @type {Date}
     * @memberof Audit
     */
    created_at: Date;
}

/**
 * Check if a given object implements the Audit interface.
 */
export function instanceOfAudit(value: object): value is Audit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('more_detail' in value) || value['more_detail'] === undefined) return false;
    if (!('detail' in value) || value['detail'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function AuditFromJSON(json: any): Audit {
    return AuditFromJSONTyped(json, false);
}

export function AuditFromJSONTyped(json: any, ignoreDiscriminator: boolean): Audit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'description': json['description'],
        'more_detail': json['more_detail'],
        'detail': json['detail'],
        'type': json['type'],
        'claim_ref': json['claim_ref'] == null ? undefined : json['claim_ref'],
        'user': json['user'] == null ? undefined : UserFromJSON(json['user']),
        'created_at': (new Date(json['created_at'])),
    };
}

export function AuditToJSON(json: any): Audit {
    return AuditToJSONTyped(json, false);
}

export function AuditToJSONTyped(value?: Audit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'more_detail': value['more_detail'],
        'detail': value['detail'],
        'type': value['type'],
        'claim_ref': value['claim_ref'],
        'user': UserToJSON(value['user']),
        'created_at': ((value['created_at']).toISOString().substring(0,10)),
    };
}

